const VIETNAM_UTC_OFFSET_HOURS = 7;

function pad(value) {
  return String(value).padStart(2, "0");
}

function partsFromSelectedDate(date) {
  return {
    year: date.getFullYear(),
    month: date.getMonth(),
    day: date.getDate(),
    hour: date.getHours(),
    minute: date.getMinutes(),
    second: date.getSeconds(),
    millisecond: date.getMilliseconds()
  };
}

function partsFromVietnamNow() {
  const vietnamDate = new Date(Date.now() + VIETNAM_UTC_OFFSET_HOURS * 60 * 60 * 1000);
  return {
    year: vietnamDate.getUTCFullYear(),
    month: vietnamDate.getUTCMonth(),
    day: vietnamDate.getUTCDate(),
    hour: vietnamDate.getUTCHours(),
    minute: vietnamDate.getUTCMinutes(),
    second: vietnamDate.getUTCSeconds(),
    millisecond: vietnamDate.getUTCMilliseconds()
  };
}

function unixFromVietnamParts(parts) {
  return Math.floor(Date.UTC(
    parts.year,
    parts.month,
    parts.day,
    parts.hour - VIETNAM_UTC_OFFSET_HOURS,
    parts.minute,
    parts.second,
    parts.millisecond
  ) / 1000);
}

export function vietnamUnixFromDate(date) {
  return unixFromVietnamParts(partsFromSelectedDate(date));
}

export function vietnamStartOfTodayUnix() {
  const parts = partsFromVietnamNow();
  return unixFromVietnamParts({ ...parts, hour: 0, minute: 0, second: 0, millisecond: 0 });
}

export function vietnamEndOfTodayUnix() {
  const parts = partsFromVietnamNow();
  return unixFromVietnamParts({ ...parts, hour: 23, minute: 59, second: 59, millisecond: 999 });
}

export function formatVietnamSelectedDate(date, format = "DD-MM-YYYY") {
  const parts = partsFromSelectedDate(date);
  if (format === "DDMMYY") {
    return `${pad(parts.day)}${pad(parts.month + 1)}${String(parts.year).slice(-2)}`;
  }
  return `${pad(parts.day)}-${pad(parts.month + 1)}-${parts.year}`;
}

export function formatVietnamToday(format = "DD-MM-YYYY") {
  const parts = partsFromVietnamNow();
  if (format === "DDMMYY") {
    return `${pad(parts.day)}${pad(parts.month + 1)}${String(parts.year).slice(-2)}`;
  }
  return `${pad(parts.day)}-${pad(parts.month + 1)}-${parts.year}`;
}
